import axios from "axios";

const isProduction = process.env.NODE_ENV === "production";
const API_URL = (window as any).API_URL;

export const api = axios.create({
  baseURL: isProduction ? API_URL + "/api" : process.env.REACT_APP_DEV_URL + "/api",
});

export const apiBlobFile = axios.create({
  baseURL: isProduction ? API_URL + "/api" : process.env.REACT_APP_DEV_URL + "/api",
});

export const BACKEND_URL = isProduction ? API_URL : process.env.REACT_APP_DEV_URL;
export const BACKEND_URL_API = BACKEND_URL + "/api";

let authInterceptorID: number;

export const authenticateAPI = (token: string) => {
  authInterceptorID = api.interceptors.request.use((config) => {
    config.headers.authorization = `bearer ${token}`;
    return config;
  });
};

export const unauthenticateAPI = () => {
  api.interceptors.request.eject(authInterceptorID);
};
